<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="">
        <div class="card-content ">
          <reward-form :modeldata="model" :defaultData="defaultData"></reward-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RewardForm from '../../RewardProgram/RewardProgramForm.vue'

export default {
  components: {
    RewardForm
  },
  created () {
    this.loadSettings()
    this.$bus.$on('company-data-updated', this.onCompanyDataUpdated)
  },
  beforeDestroy () {
    this.$bus.$off('company-data-updated', this.onCompanyDataUpdated)
  },
  data () {
    return {
      model: {},
      defaultData: {
        'available_languages': {},
        'countries': {},
        'currencies': {},
        'currency_display_format': [],
        'date_formats': [],
        'time_formats': [],
        'timezones': {}
      }
    }
  },
  props: {
    isLoyality: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isLoyality () {
      if (this.isLoyality) {
        this.loadSettings()
      }
    }
  },
  methods: {
    loadSettings () {
      const data = {
        token: this.$session.get('token')
      }
      const companyID = this.$session.get('selectedCompany')

      this.apiRequest('/listdefaults', 'GET', data, response => {
        if (response.status === true) {
          this.defaultData = response.data[0]
        }
      })

      this.apiRequest('/settings/general/' + companyID, 'GET', data, response => {
        if (response.status === true) {
          this.model = response.data[0]
          this.updateSelectedCompanyCache(response.data[0])
        }
      })
    },
    isLoyaltyInUseEnabled (value) {
      return value === true || value === 1 || value === '1' || value === 'true'
    },
    normalizeCompanyCacheData (companyData) {
      if (!companyData) return companyData
      const cached = Object.assign({}, companyData)
      cached.loyalty_in_use = this.isLoyaltyInUseEnabled(cached.loyalty_in_use)
      return cached
    },
    updateSelectedCompanyCache (companyData) {
      if (!companyData) return
      const cached = this.normalizeCompanyCacheData(companyData)
      this.$session.set('selectedCompanyData', cached)
      this.$bus.$emit('company-data-updated', cached)
    },
    onCompanyDataUpdated (companyData) {
      if (!companyData || String(companyData.id) !== String(this.$session.get('selectedCompany'))) return
      this.model = Object.assign({}, this.model, companyData)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Fidelities/Loyality.vue